module.exports = __webpack_public_path__ + "img/expert.e9635f7d.svg";